import React from "react";
import {NestAdInfinitum} from "../AdInfinitum";

interface ContextPropsProviderProps {
    children: React.ReactNode;
    providers?: React.FC<any>[];
}

export const ContextPropsProvider: React.FC<ContextPropsProviderProps> = ({
    children,
    providers,
}: ContextPropsProviderProps) => {
    return (
        <NestAdInfinitum array={providers ?? []}>
            {children}
        </NestAdInfinitum>
    );
};

interface ContextPropsConsumerProps {
    children?: (React.FC<any> | undefined)[];
    contexts?: (() => any)[];
    props?: Record<string, any>;
}

export const ContextPropsConsumer: React.FC<ContextPropsConsumerProps> = ({
                                     children,
                                     contexts,
                                     props,
                                 }: ContextPropsConsumerProps) => {
let contextProps: Record<string, unknown> = {};

    contexts?.forEach((context: () => Record<string, unknown>) => Object.assign(contextProps, context()));

    return (
        children?.map((Component, key: number) => {
                if (!Component) return null;
                return <Component
                    key={key}
                    {...props}
                    {...contextProps}
                />
            },
        ) ?? null
    );
};
